<p-dropdown [options]="appSettings.time_states" [(ngModel)]="time_state" (onChange)="emitTime()" placeholder="Не выбрано">
  <ng-template let-item pTemplate="selectedItem">
    {{ appSettings.translate[appSettings.selectedLang][item.label] }}
  </ng-template>
  <ng-template let-item pTemplate="item">
    {{ appSettings.translate[appSettings.selectedLang][item.label] }}
  </ng-template>
</p-dropdown>
